// extracted by mini-css-extract-plugin
export default {"minesTablesWrap":"styles_minesTablesWrap__t3vmv","minesTableMyBetsWrap":"styles_minesTableMyBetsWrap__JshTF"};